import { Description } from '@page/integration-view/integration-view.page-style';
import { PageTitle, PageWrapper } from '@style/pages/page.style';

import { RequestExternalIntegration } from '@component/request-external-integration/request-external-integration';

import { MainWrapper } from './request-external-integration.page.style';

export const RequestExternalIntegrationPage = () => (
  <PageWrapper>
    <PageTitle>Request new integration</PageTitle>
    <Description>
      Thank you for your interest in Universal API. We are happy to explore integrations for additional services or
      products. Please provide the following information so we can better understand your needs.
    </Description>
    <MainWrapper>
      <RequestExternalIntegration />
    </MainWrapper>
  </PageWrapper>
);
